import { Component, computed, inject, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectSettingsService } from '../../services/project-settings.service';

@Component({
  selector: 'app-deposit-address-missing',
  imports: [TranslateModule],
  templateUrl: './deposit-address-missing.component.html',
})
export class DepositAddressMissingComponent {
  private readonly projectSettingsService: ProjectSettingsService = inject(ProjectSettingsService);

  public readonly supportUrl: Signal<string | null> = computed(() => {
    const username = this.projectSettingsService.settings()?.supportUsername ?? '';
    const normalized = username.startsWith('@') ? username.slice(1) : username;
    return normalized ? `https://telegram.me/${normalized}` : null;
  });
}
